<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/research"></imgBigCards>
    <!-- 输入框 -->
    <!-- <div class="box-input">
      <inputBox></inputBox>
    </div> -->
    <div class="box-content">
      <div class="content-left">
        <div class="left-one">
          <div class="one-title">
            <p>
              {{ mydata.articleInfo.title }}
            </p>
            <P>
              <span
                >发表时间：
                {{
                  dayjs(mydata.articleInfo.release_time * 1000).format(
                    "YYYY-MM-DD"
                  )
                }}
              </span>
              <span style="margin-right: 34px"
                >来源：{{ mydata.articleInfo.source }}</span
              >
              <span
                >关键词：
                <span
                  v-for="(item, index) in mydata.articleInfo.tags"
                  :key="index"
                  style="margin-right:10px;"
                  >{{ item.name }}</span
                >
              </span>
            </P>
          </div>
          <div class="one-content">
            <p class="tableA" v-html="mydata.articleInfo.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 新书上架
// import rightCardNewBook from "@/components/rightCardNewBook/index.vue";
// 必刷好题
import rightCardProblem from "@/components/rightCardProblem/index.vue";

import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock, CollectionTag } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";

import { reactive, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

// 引入加入收藏、取消收藏接口
import {
  addFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";

// 新书推荐
import { bookNew } from "@/api/addedServices/index.js";
//获取淘题搜索列表接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";
// 引入接口
import { articleList } from "@/api/home/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  bookNew: [], // 新书推荐
  examSearchList: [], // 热门资源
  articleListArr: [], // 活动成果
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId("/layout/list/projectAchievements"), // 栏目id值
    search: "", // 搜索查询
    stage: "", //学段
    theme: "", //主题
    subject: "", //学科
  },
});

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
        // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes('/layout/list/cooperatePlate')) {return}
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log("文章接口上一页下一页", res.data);
    mydata.articleInfo = res.data;
  });
}

// init();

// 新书推荐
function bookNewFN() {
  bookNew().then((res) => {
    mydata.bookNew = res.data.list;
  });
}
bookNewFN();

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.articleInfo.is_collect !== 0) {
    // 调用取消收藏接口
    delFavoritesList(mydata.userInfo.jwt, {
      favorite_id: mydata.articleInfo.id,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 3,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

///我要加入按钮————教师活动报名
function teacherButton() {
  router.push({
    path: "/layout/list/thisEventRegistrationTeacher",
    query: { id: mydata.articleId },
  });
}

// 淘题搜索列表
function examSearchListFN() {
  examSearchList({ is_recommended: 1 }).then((res) => {
    mydata.examSearchList = res.data.list;
  });
}
examSearchListFN();

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}
articleListFn();

function goPrevOrNext(id) {
  if (id === undefined) {
    return;
  }

  router.push({
    path: "/layout/list/researchDetails",
    query: { id },
  });
}

//活动成果内容点击
function activeClick(id) {
  router.push({
    path: "/layout/list/worksDisplayDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    background-color: #ffffff;
    padding: 16px 16px 20px 16px;
    .one-title {
      p:nth-of-type(1) {
        min-height: 28px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;

        line-height: 28px;
        // height: 56px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
       p:nth-of-type(2) {
        display: flex;
        flex-wrap:wrap;
        // border:1px solid red;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #888888;
        margin-top: 12px;
        > span {
          margin-right: 34px;
        }
      }
    }
    ////内容部分
    .one-content {
      width: 343px;
      // height:1824px;
      // border: 1px solid blue;
      margin-top: 24px;
      // img {
      //   width: 720px;
      //   height: 480px;
      //   margin: 0 auto;
      //   display: block;
      //   // border:1px solid yellow;
      // }
      p {
        margin-top: 24px;
        white-space: pre-wrap;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        // color:red;
      }
    }

    // .one-foot {
    //   width: 343px;
    //   // height: 84px;
    //   // border: 1px solid red;
    //   border-top: 1px dashed #cccccc;
    //   margin-top: 26px;
    //   p {
    //     font-size: 14px;
    //     font-weight: 400;
    //     color: #333333;
    //     line-height: 22px;
    //     white-space: nowrap; //不折行
    //     text-overflow: ellipsis; //文本溢出 用省略号显示
    //     overflow: hidden;
    //   }
    //   p:nth-of-type(1) {
    //     margin-top: 24px;
    //   }
    //   p:nth-of-type(2) {
    //     margin-top: 16px;
    //   }
    //   p:hover {
    //     color: #009de0;
    //   }
    // }

    // }
    //////右边
    // .box-right {
    //   width: 320px;
    //   // border:1px solid rgb(255, 174, 0);
    //   border-radius: 8px;
    //   .activity-results {
    //     width: 320px;
    //     .box-content img {
    //       width: 256px;
    //       height: 145px;
    //       border-radius: 8px;
    //       margin-bottom: 20px;
    //       display: block;
    //     }
    //     .box-content img:nth-last-of-type(1) {
    //       margin-bottom: 0px;
    //     }
    //   }
    // }
  }
}
</style>
